import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import classnames from "classnames";
import React from "react";
import "./style.less";

export interface ToggleButtonMapProps {
  className?: string;
  isToggled: boolean;
}

export interface ToggleButtonActionProps {
  onClick: () => void;
}

const ToggleButton = (props: ToggleButtonActionProps & ToggleButtonMapProps) => (
  <button
    className={classnames(props.className, "wsc_lines_button", { active: props.isToggled })}
    onClick={(e) => (e.preventDefault(), props.onClick())}
  >
    <span className="lines"></span>
  </button>
);

export default ToggleButton;

export const VisibleToggleButton = withIsVisibleHOC(ToggleButton);

export const INVISIBLE_PROPS: ToggleButtonActionProps & ToggleButtonMapProps & WithIsVisibleHOCProps = {
  isToggled: false,
  isVisible: false,
  onClick: () => null
};
